/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconLighthouse: {
  name: 'lighthouse';
  data: string;
} = {
  name: 'lighthouse',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M298.875 152.993 298.875 191.243 585.75 267.743 585.75 57.368z"/><path d="M289.313 229.493V95.618l-114.75-57.375-114.75 57.375v133.875h36.704L21.563 592.868h306l-74.954-363.375h36.704zM88.5 114.743h172.125v76.5H88.5v-76.5z"/></svg>`,
};
